import { isShipmentMissingScenario } from "./utils";

const $getClaimForm = () => document.getElementById("new_request_claim");
const $getClaimFormSubmitButton = () => document.getElementById("js-submit-claim-request");
const $getAllQuantityInputs = () =>
  document.querySelectorAll('input[name*="[request_items_attributes]"][name*="[quantity]"]');

const prepareShipmentMissingSubmission = () => {
  // Ensure all quantities are set to max for shipment missing
  if (isShipmentMissingScenario()) {
    const $quantityInputs = $getAllQuantityInputs();
    $quantityInputs.forEach($input => {
      // eslint-disable-next-line no-param-reassign
      $input.value = $input.getAttribute("max") ?? $input.value;
    });
  }
};

const handleSubmitClaimSubmit = event => {
  event.preventDefault();
  const $submitClaimForm = $getClaimForm();

  prepareShipmentMissingSubmission();

  if ($submitClaimForm.checkValidity()) {
    const $claimFormSubmitButton = $getClaimFormSubmitButton();
    $claimFormSubmitButton.value = "Submitting...";
    $claimFormSubmitButton.disabled = true;
    $submitClaimForm.submit();
  } else {
    $submitClaimForm.reportValidity();
  }
};

export default () => {
  const $submitClaimForm = $getClaimForm();
  if ($submitClaimForm) {
    $submitClaimForm.addEventListener("submit", handleSubmitClaimSubmit);
  }
};
